<template>
  <div>
    <a-card :bordered="false" class="report-filter-card">
      <div class="report-title-row">
        <div>
          <div class="report-title">BÁO CÁO ENTRY</div>
          <div class="report-subtitle">
            Tra cứu và xuất dữ liệu Entry theo điều kiện
          </div>
        </div>

        <div class="report-total">{{ FormatNumber(Total) }} bản ghi</div>
      </div>

      <div class="quick-date-actions">
        <span class="filter-label quick-date-label">CHỌN NHANH:</span>

        <a-button
          size="small"
          :type="DatePreset === 'TODAY' ? 'primary' : 'default'"
          @click="ApplyDatePreset('TODAY')"
        >
          HÔM NAY
        </a-button>

        <a-button
          size="small"
          :type="DatePreset === 'YESTERDAY' ? 'primary' : 'default'"
          @click="ApplyDatePreset('YESTERDAY')"
        >
          HÔM QUA
        </a-button>

        <a-button
          size="small"
          :type="DatePreset === 'THIS_WEEK' ? 'primary' : 'default'"
          @click="ApplyDatePreset('THIS_WEEK')"
        >
          TUẦN NÀY
        </a-button>

        <a-button
          size="small"
          :type="DatePreset === 'LAST_WEEK' ? 'primary' : 'default'"
          @click="ApplyDatePreset('LAST_WEEK')"
        >
          TUẦN TRƯỚC
        </a-button>
      </div>

      <div class="report-filter-stack">
        <div class="report-filter-row">
          <div class="filter-block filter-block-date">
            <div class="filter-label">TỪ NGÀY</div>
            <a-date-picker
              v-model="Filter.From"
              format="DD/MM/YYYY"
              value-format="YYYY-MM-DD"
              placeholder="Từ ngày"
              class="compact-date-picker"
              :allow-clear="false"
              @change="DatePreset = ''"
            />
          </div>

          <div class="filter-block filter-block-date">
            <div class="filter-label">ĐẾN NGÀY</div>
            <a-date-picker
              v-model="Filter.To"
              format="DD/MM/YYYY"
              value-format="YYYY-MM-DD"
              placeholder="Đến ngày"
              class="compact-date-picker"
              :allow-clear="false"
              @change="DatePreset = ''"
            />
          </div>

          <div class="filter-block filter-block-scratch">
            <div class="filter-label">TRẠNG THÁI MÃ</div>
            <a-select
              v-model="Filter.Scratch_Status"
              mode="multiple"
              allow-clear
              placeholder="Tất cả"
              class="scratch-status-select"
              :max-tag-count="2"
              :max-tag-text-length="14"
            >
              <a-select-option
                v-for="Item in ScratchStatusOptions"
                :key="Item.Value"
                :value="Item.Value"
              >
                {{ Item.Label }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div class="report-filter-row">
          <div class="filter-block">
            <div class="filter-label">HÌNH THỨC NHẬN</div>
            <a-radio-group
              v-model="Filter.IsCashout"
              button-style="solid"
              class="report-radio-group"
            >
              <a-radio-button value="">Tất cả</a-radio-button>
              <a-radio-button value="false">
                <a-icon type="gift" /> Voucher
              </a-radio-button>
              <a-radio-button value="true">
                <a-icon type="dollar" /> Tiền mặt
              </a-radio-button>
            </a-radio-group>
          </div>

          <div class="filter-block">
            <div class="filter-label">HÌNH THỨC TRẢ THƯỞNG</div>
            <a-radio-group
              v-model="Filter.IsDistributed"
              button-style="solid"
              class="report-radio-group"
            >
              <a-radio-button value="">Tất cả</a-radio-button>
              <a-radio-button value="true">Đã trả</a-radio-button>
              <a-radio-button value="false">Chưa trả</a-radio-button>
            </a-radio-group>
          </div>
        </div>

        <div class="report-filter-row">
          <div class="filter-block toggle-filter-block">
            <div class="filter-label">LẤY ĐỊA CHỈ</div>
            <div class="toggle-wrap">
              <a-switch
                v-model="Filter.IncludeAddress"
                checked-children="ON"
                un-checked-children="OFF"
              />
              <span class="toggle-text">
                {{ Filter.IncludeAddress ? "Có" : "Không" }}
              </span>
            </div>
          </div>

          <div class="filter-block toggle-filter-block">
            <div class="filter-label">LẤY GIỚI TÍNH</div>
            <div class="toggle-wrap">
              <a-switch
                v-model="Filter.IncludeGender"
                checked-children="ON"
                un-checked-children="OFF"
              />
              <span class="toggle-text">
                {{ Filter.IncludeGender ? "Có" : "Không" }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="report-actions report-actions--center">
        <a-button
          type="primary"
          icon="search"
          :loading="Loading"
          @click="HandleSearch"
        >
          Tìm kiếm
        </a-button>

        <a-button
          icon="reload"
          :disabled="Loading || Exporting"
          @click="ResetFilter"
        >
          Đặt lại
        </a-button>

        <a-button
          class="export-button"
          icon="download"
          :loading="Exporting"
          @click="ExportReport"
        >
          Xuất
        </a-button>
      </div>
    </a-card>

    <a-row :gutter="8" class="summary-row">
      <a-col
        v-for="Card in ReportSummaryCards"
        :key="Card.Key"
        :xl="4"
        :lg="8"
        :md="12"
        :sm="12"
        :xs="24"
      >
        <a-card :bordered="false" class="report-summary-card">
          <div class="report-summary-title">
            {{ Card.Title }}
          </div>
          <div class="report-summary-value">
            {{ FormatNumber(Card.Value) }}
          </div>
        </a-card>
      </a-col>
    </a-row>

    <a-alert
      v-if="SearchIssueSummary && SearchIssueSummary.ISSUE_COUNT > 0"
      type="warning"
      show-icon
      class="distribution-alert"
      :message="`Có ${FormatNumber(SearchIssueSummary.ISSUE_COUNT)} Entry cần kiểm tra trong kết quả tìm kiếm`"
      :description="GetSearchIssueSummaryText()"
    />

    <a-alert
      v-if="ExportAlert.Visible"
      class="distribution-alert"
      :type="ExportAlert.Type"
      :message="ExportAlert.Message"
      :description="ExportAlert.Description"
      show-icon
      closable
      @close="ClearExportAlert"
    />

    <a-card :bordered="false" class="report-table-card">
      <a-table
        row-key="Request_ID"
        :columns="VisibleColumns"
        :data-source="Entries"
        :loading="Loading"
        :pagination="Pagination"
        :scroll="{ x: TableScrollX }"
        size="middle"
        @change="HandleTableChange"
      >
        <template slot="Request_ID" slot-scope="Value, Record">
          <a-tag
            class="report-link-tag"
            :color="GetScratchStatusColor(Record.Scratch_Status)"
            @click="OpenEntryInNewTab(Record)"
          >
            {{ Value }}
          </a-tag>
          <br />
          <span class="request-time">
            {{ FormatDateTime(Record.Created_At) }}
          </span>
        </template>

        <template slot="Scratch_Code" slot-scope="Value, Record">
          <a-tag
            class="code_format report-link-tag"
            @click="OpenEntryInNewTab(Record)"
          >
            {{ Value || "-" }}
          </a-tag>
          <a-tag :color="GetScratchStatusColor(Record.Scratch_Status)">
            {{ GetScratchStatusLabel(Record.Scratch_Status) || "-" }}
          </a-tag>
        </template>
        <template slot="Gender" slot-scope="text">  {{
  String(text || "").toUpperCase() === "MALE"
    ? "Nam"
    : String(text || "").toUpperCase() === "FEMALE"
      ? "Nữ"
      : text || "-"
}}
</template>

        <template slot="Reward" slot-scope="Value, Record">
          <template v-if="IsSuccessScratch(Record.Scratch_Status)">
            <a-tag :color="Record.IsCashout ? '#52c41a' : '#1890ff'">
              <a-icon :type="Record.IsCashout ? 'dollar' : 'gift'" />
              {{ Record.IsCashout ? "Tiền mặt" : "Voucher" }}
            </a-tag>

            <br />

            <a-tag
              class="reward-status-tag"
              :color="GetDistributionStatusColor(Record)"
            >
              {{ GetDistributionStatusLabel(Record) }}
            </a-tag>
          </template>
          <span v-else>-</span>
        </template>

        <template slot="IsExport" slot-scope="Value">
          <a-tag :color="Value ? '#52c41a' : '#d9d9d9'">
            {{ Value ? "ĐÃ XUẤT" : "CHƯA XUẤT" }}
          </a-tag>
        </template>

        <template slot="Voucher_DLR_Status" slot-scope="Value, Record">
          <a-tag
            v-if="ShouldShowVoucherFinalStatus(Record)"
            :color="GetVoucherFinalStatusColor(Record)"
          >
            {{ GetVoucherFinalStatusLabel(Record) }}
          </a-tag>
        </template>
        <template slot="Voucher_Capture_Status" slot-scope="Value, Record">
          <a-tag
            v-if="ShouldShowVoucherCapture(Record)"
            :class="{
              'report-link-tag': CanPreviewVoucherImage(Record),
            }"
            :color="GetVoucherCaptureStatusColor(Value, Record)"
            @click="PreviewVoucherImage(Record)"
          >
            {{ GetVoucherCaptureStatusLabel(Value, Record) }}
            <a-icon
              v-if="CanPreviewVoucherImage(Record)"
              type="eye"
            />
          </a-tag>
        </template>
      </a-table>
    </a-card>

    <a-modal
      v-model="ImagePreview.Visible"
      title="Ảnh ZNS Voucher"
      :footer="null"
      :width="900"
      centered
      @cancel="CloseImagePreview"
    >
      <div class="report-image-preview">
        <img
          v-if="ImagePreview.URL"
          :src="ImagePreview.URL"
          :alt="ImagePreview.Request_ID || 'Voucher ZNS'"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
const DEFAULT_SCRATCH_STATUS_OPTIONS = [
  {
    Value: "SUCCESS",
    Label: "Mã hợp lệ",
  },
  {
    Value: "WRONG",
    Label: "Không chính xác",
  },
  {
    Value: "DUPLICATE",
    Label: "Mã sử dụng",
  },
  {
    Value: "BLOCK",
    Label: "KH tạm khóa",
  },
  {
    Value: "BLACKLIST",
    Label: "KH đã khóa",
  },
  {
    Value: "ENDDATE",
    Label: "CT Kết thúc",
  },
];

const DB_STATUS_TO_UI = {
  Success: "SUCCESS",
  Wrong: "WRONG",
  Duplicate: "DUPLICATE",
  Block: "BLOCK",
  BlackList: "BLACKLIST",
  EndTime: "ENDDATE",
};

export default {
  name: "EntryReport",
  props: {
    Token: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      ExportAlert: {
        Visible: false,
        Type: "info",
        Message: "",
        Description: "",
      },

      Loading: false,
      Exporting: false,
      DatePreset: "TODAY",

      Filter: this.BuildDefaultFilter(),

      Entries: [],
      ImagePreview: {
        Visible: false,
        URL: "",
        Request_ID: "",
      },
      Total: 0,
      DistributionSummary: null,
      SearchIssueSummary: null,

      ReportSummary: {
        Total_Success: 0,
        Completed_Total: 0,
        Voucher_Pending: 0,
        Voucher_Failed: 0,
        Not_Exported: 0,
        Missing_ZNS_Image: 0,
        Cashout_Total: 0,
      },

      ScratchStatusOptions: DEFAULT_SCRATCH_STATUS_OPTIONS.slice(),

      Columns: [
        {
          title: "Request ID",
          dataIndex: "Request_ID",
          key: "Request_ID",
          width: 165,
          fixed: "left",
          align: "center",
          scopedSlots: {
            customRender: "Request_ID",
          },
        },
        {
          title: "Họ tên",
          dataIndex: "Full_Name",
          key: "Full_Name",
          width: 160,
        },
        {
          title: "SĐT",
          dataIndex: "User_ID",
          key: "User_ID",
          width: 100,
          align: "center",
        },
        {
          title: "Địa chỉ",
          dataIndex: "Address",
          key: "Address",
          width: 280,
        },
        {
          title: "Giới tính",
          dataIndex: "Gender",
          key: "Gender",
          width: 90,
          align: "center",
          scopedSlots: {
            customRender: "Gender",
          },
        },
        {
          title: "CCCD",
          dataIndex: "CCCD",
          key: "CCCD",
          width: 120,
          align: "center",
        },
        {
          title: "Mã dự thưởng",
          dataIndex: "Scratch_Code",
          key: "Scratch_Code",
          width: 160,
          align: "center",
          scopedSlots: {
            customRender: "Scratch_Code",
          },
        },
        {
          title: "Trả Thưởng",
          key: "Reward",
          width: 150,
          align: "center",
          scopedSlots: {
            customRender: "Reward",
          },
        },
        {
          title: "Xuất báo cáo",
          dataIndex: "IsExport",
          key: "IsExport",
          width: 110,
          align: "center",
          scopedSlots: {
            customRender: "IsExport",
          },
        },
        {
          title: "Trạng thái Voucher cuối",
          dataIndex: "Voucher_Distribution_Final_Status",
          key: "Voucher_DLR_Status",
          width: 220,
          align: "center",
          scopedSlots: {
            customRender: "Voucher_DLR_Status",
          },
        },
        {
          title: "Voucher Capture",
          dataIndex: "Voucher_Distribution_Capture_Status",
          key: "Voucher_Distribution_Capture_Status",
          width: 150,
          align: "center",
          scopedSlots: {
            customRender: "Voucher_Capture_Status",
          },
        },
      ],
    };
  },

  computed: {
    ...mapState(["oUser"]),

    GetToken() {
      if(this.oUser && this.oUser.Token)
        return this.oUser.Token;
      return "";
    },
    ReportSummaryCards() {
      const Summary = this.ReportSummary || {};

      return [
        {
          Key: "Total_Success",
          Title: "TỔNG ENTRY ĐÚNG MÃ",
          Value: Number(Summary.Total_Success || 0),
        },
        {
          Key: "Completed_Total",
          Title: "ĐÃ XỬ LÝ (HOÀN TẤT)",
          Value: Number(Summary.Completed_Total || 0),
        },
        {
          Key: "Voucher_Pending",
          Title: "CHƯA TRẢ VOUCHER",
          Value: Number(Summary.Voucher_Pending || 0),
        },
        {
          Key: "Voucher_Failed",
          Title: "TRẢ VOUCHER LỖI",
          Value: Number(Summary.Voucher_Failed || 0),
        },
        {
          Key: "Not_Exported",
          Title: "CHƯA XUẤT",
          Value: Number(Summary.Not_Exported || 0),
        },
        {
          Key: "Missing_ZNS_Image",
          Title: "CHƯA CÓ ẢNH ZNS",
          Value: Number(Summary.Missing_ZNS_Image || 0),
        },
        {
          Key: "Cashout_Total",
          Title: "NHẬN TIỀN MẶT",
          Value: Number(Summary.Cashout_Total || 0),
        },
      ];
    },

    VisibleColumns() {
      return this.Columns.filter((Column) => {
        if (
          Column.key === "Address" &&
          this.Filter.IncludeAddress !== true
        ) {
          return false;
        }

        if (
          Column.key === "Gender" &&
          this.Filter.IncludeGender !== true
        ) {
          return false;
        }

        return true;
      });
    },

    TableScrollX() {
      let Width = 1870;

      if (this.Filter.IncludeAddress === true) {
        Width += 280;
      }

      if (this.Filter.IncludeGender === true) {
        Width += 90;
      }

      return Width;
    },

    Pagination() {
      return {
        current: this.Filter.Page,
        pageSize: this.Filter.PageSize,
        total: this.Total,
        showSizeChanger: true,
        pageSizeOptions: ["20", "50", "100", "200"],
        showTotal: (Total) => "Tổng " + this.FormatNumber(Total) + " bản ghi",
      };
    },
  },

  mounted() {
    this.LoadReportSummary();
  },

  methods: {
    OpenEntryInNewTab(Record) {
      const RequestID = String(
        (Record && Record.Request_ID) || "",
      ).trim();

      if (!RequestID) {
        return;
      }

      const URL =
        window.location.origin +
        "/?Request_ID=" +
        encodeURIComponent(RequestID);

      window.open(URL, "_blank", "noopener,noreferrer");
    },

    CanPreviewVoucherImage(Record) {
      if (!Record) {
        return false;
      }

      const Status = String(
        Record.Voucher_Distribution_Capture_Status || "",
      )
        .trim()
        .toUpperCase();

      return !!(
        Status === "SUCCESS" &&
        String(Record.Voucher_Distribution_Image || "").trim()
      );
    },

    GetVoucherImageURL(Record) {
      const Value = String(
        (Record && Record.Voucher_Distribution_Image) || "",
      ).trim();

      if (!Value) {
        return "";
      }

      const BaseURL = /^https?:\/\//i.test(Value)
        ? Value
        : (
            Value.charAt(0) === "/"
              ? Value
              : "/" + Value
          );

      /*
       * Hỗ trợ cả:
       * - computed: GetToken
       * - method: GetToken()
       *
       * Props Token là fallback cuối.
       */
      const RawToken =
        typeof this.GetToken === "function"
          ? this.GetToken()
          : this.GetToken;

      const Token = String(
        RawToken ||
        this.Token ||
        "",
      ).trim();

      if (!Token) {
        return BaseURL;
      }

      return (
        BaseURL +
        (BaseURL.includes("?") ? "&" : "?") +
        "Token=" +
        encodeURIComponent(Token)
      );
    },

    PreviewVoucherImage(Record) {
      if (!this.CanPreviewVoucherImage(Record)) {
        return;
      }

      this.ImagePreview = {
        Visible: true,
        URL: this.GetVoucherImageURL(Record),
        Request_ID: Record.Request_ID || "",
      };
    },

    CloseImagePreview() {
      this.ImagePreview = {
        Visible: false,
        URL: "",
        Request_ID: "",
      };
    },

    BuildDefaultFilter() {
      return {
        From: this.FormatDateForAPI(new Date()),
        To: this.FormatDateForAPI(new Date()),
        Scratch_Status: [],
        IsCashout: "",
        IsDistributed: "",
        IncludeAddress: false,
        IncludeGender: false,
        Page: 1,
        PageSize: 50,
      };
    },

    GetMonday(Value) {
      const DateValue = new Date(Value);

      DateValue.setHours(0, 0, 0, 0);

      const Day = DateValue.getDay();
      const Diff = Day === 0 ? -6 : 1 - Day;

      DateValue.setDate(DateValue.getDate() + Diff);

      return DateValue;
    },

    AddDays(Value, Days) {
      const DateValue = new Date(Value);

      DateValue.setDate(DateValue.getDate() + Days);

      return DateValue;
    },

    ApplyDatePreset(Type) {
      const Today = new Date();
      let From = Today;
      let To = Today;

      if (Type === "YESTERDAY") {
        From = this.AddDays(Today, -1);
        To = this.AddDays(Today, -1);
      } else if (Type === "THIS_WEEK") {
        From = this.GetMonday(Today);
      } else if (Type === "LAST_WEEK") {
        const ThisMonday = this.GetMonday(Today);

        From = this.AddDays(ThisMonday, -7);
        To = this.AddDays(ThisMonday, -1);
      }

      this.DatePreset = Type;
      this.Filter.From = this.FormatDateForAPI(From);
      this.Filter.To = this.FormatDateForAPI(To);
      this.Filter.Page = 1;

      this.SearchReport();
    },

    FormatDateForAPI(Value) {
      const DateValue = Value instanceof Date ? Value : new Date(Value);

      if (Number.isNaN(DateValue.getTime())) {
        return "";
      }

      const Pad = (NumberValue) => String(NumberValue).padStart(2, "0");

      return [
        DateValue.getFullYear(),
        Pad(DateValue.getMonth() + 1),
        Pad(DateValue.getDate()),
      ].join("-");
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "-";
      }

      const DateValue = new Date(Value);

      if (Number.isNaN(DateValue.getTime())) {
        return Value;
      }

      const Pad = (NumberValue) => String(NumberValue).padStart(2, "0");

      return [
        Pad(DateValue.getDate()),
        "/",
        Pad(DateValue.getMonth() + 1),
        "/",
        DateValue.getFullYear(),
        " ",
        Pad(DateValue.getHours()),
        ":",
        Pad(DateValue.getMinutes()),
        ":",
        Pad(DateValue.getSeconds()),
      ].join("");
    },

    FormatNumber(Value) {
      return Number(Value || 0).toLocaleString("vi-VN");
    },

    BuildRequestData() {
      const Data = {
        From: this.Filter.From,
        To: this.Filter.To,
        Scratch_Status: this.Filter.Scratch_Status || [],
        IncludeAddress: this.Filter.IncludeAddress === true,
        IncludeGender: this.Filter.IncludeGender === true,
        Page: this.Filter.Page,
        PageSize: this.Filter.PageSize,
      };

      if (
        this.Filter.IsCashout === "true" ||
        this.Filter.IsCashout === "false"
      ) {
        Data.IsCashout = this.Filter.IsCashout;
      }

      if (
        this.Filter.IsDistributed === "true" ||
        this.Filter.IsDistributed === "false"
      ) {
        Data.IsDistributed = this.Filter.IsDistributed;
      }

      return Data;
    },

    async PostJSON(URL, Data) {
      const Response = await fetch(this.$PRJ_DOMAIN + URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(Data),
      });

      return await Response.json();
    },

    async LoadReportSummary() {
      try {
        const Result = await this.$PostAPI(
          "/report/summary",
          {},
        );

        if (!Result || Result.State !== 1) {
          throw new Error(
            Result && Result.Message
              ? Result.Message
              : "Không tải được counter Report.",
          );
        }

        const Data = Result.Data || {};

        this.ReportSummary = Object.assign(
          {
            Total_Success: 0,
            Completed_Total: 0,
            Voucher_Pending: 0,
            Voucher_Failed: 0,
            Not_Exported: 0,
            Missing_ZNS_Image: 0,
            Cashout_Total: 0,
          },
          Data.Summary || {},
        );
      } catch (Error) {
        console.error(
          "REPORT-SUMMARY-ERROR:",
          Error,
        );
      }
    },

    async SearchReport() {
      this.Loading = true;

      try {
        const Result = await this.$PostAPI(
          "/report/search",
          this.BuildRequestData(),
        );

        if (!Result || Result.State !== 1) {
          throw new Error(
            Result && Result.Message
              ? Result.Message
              : "Không tải được báo cáo.",
          );
        }

        const Data = Result.Data || {};

        this.Entries = Data.Entries || [];

        this.Total = Number(Data.Total || 0);
        this.DistributionSummary = Data.Distribution_Summary || null;
        this.SearchIssueSummary = Data.Issue_Summary || null;

        this.Filter.Page = Number(Data.Page || this.Filter.Page);

        this.Filter.PageSize = Number(Data.PageSize || this.Filter.PageSize);

        if (
          Data.FilterOptions &&
          Array.isArray(Data.FilterOptions.Scratch_Statuses) &&
          Data.FilterOptions.Scratch_Statuses.length
        ) {
          this.ScratchStatusOptions = Data.FilterOptions.Scratch_Statuses.map(
            (Item) => ({
              Value: Item.Value,
              Label: Item.Label,
            }),
          );
        }

        await this.LoadReportSummary();
      } catch (Error) {
        this.Entries = [];
        this.Total = 0;
        this.DistributionSummary = null;
        this.SearchIssueSummary = null;

        this.$message.error(Error.message || "Không tải được báo cáo.");
      } finally {
        this.Loading = false;
      }
    },

    HandleSearch() {
      this.Filter.Page = 1;
      this.SearchReport();
    },

    HandleTableChange(Pagination) {
      this.Filter.Page = Pagination.current || 1;

      this.Filter.PageSize = Pagination.pageSize || 50;

      this.SearchReport();
    },

    ResetFilter() {
      this.DatePreset = "TODAY";
      this.Filter = this.BuildDefaultFilter();

      this.SearchReport();
    },

    GetDistributionStatusLabel(Record) {
      if (!Record || Record.IsCashout === true) {
        return Record && Record.IsDistributed ? "Đã trả thưởng" : "Chưa trả thưởng";
      }

      const Status = String(
        Record.Voucher_Distribution_Final_Status || ""
      ).toUpperCase();

      if (Status === "DELIVERED") return "Đã gửi Voucher";
      if (Status === "WAITING_DLR") return "Đã gửi - Chờ DLR";
      if (Status === "FAILED") return "Voucher thất bại";
      if (Status === "SEND_FAILED") return "Gửi Voucher thất bại";
      if (Status === "NOT_SENT") return "Chưa gửi Voucher";

      return Record.IsDistributed ? "Đã gửi Voucher" : "Chưa gửi Voucher";
    },

    GetDistributionStatusColor(Record) {
      if (!Record) return "#d9d9d9";

      if (Record.IsCashout === true) {
        return Record.IsDistributed ? "#52c41a" : "#faad14";
      }

      const Status = String(
        Record.Voucher_Distribution_Final_Status || ""
      ).toUpperCase();

      if (Status === "DELIVERED") return "#52c41a";
      if (Status === "WAITING_DLR") return "#1890ff";
      if (Status === "FAILED" || Status === "SEND_FAILED") return "#f5222d";
      if (Status === "NOT_SENT") return "#faad14";

      return Record.IsDistributed ? "#52c41a" : "#faad14";
    },

    GetSearchIssueSummaryText() {
      const Summary = this.SearchIssueSummary || {};

      return [
        `Chưa xuất: ${this.FormatNumber(Summary.NOT_EXPORTED || 0)}`,
        `Chưa có ảnh ZNS: ${this.FormatNumber(Summary.MISSING_IMAGE || 0)}`,
        `Chưa gửi Voucher: ${this.FormatNumber(Summary.VOUCHER_NOT_SENT || 0)}`,
        `Voucher lỗi: ${this.FormatNumber(Summary.VOUCHER_FAILED || 0)}`,
      ].join(" | ");
    },

    GetDistributionSummaryText() {
      const Summary = this.DistributionSummary || {};

      return [
        `Đang chờ DLR: ${Number(Summary.WAITING_DLR || 0)}`,
        `DLR lỗi: ${Number(Summary.FAILED || 0)}`,
        `Gọi Voucher lỗi: ${Number(Summary.SEND_FAILED || 0)}`,
        `Chưa gửi: ${Number(Summary.NOT_SENT || 0)}`,
      ].join(" | ");
    },

    GetScratchStatusCode(Value) {
      if (!Value) {
        return "";
      }

      const Text = String(Value);

      if (DB_STATUS_TO_UI[Text]) {
        return DB_STATUS_TO_UI[Text];
      }

      return Text.toUpperCase();
    },

    GetScratchStatusLabel(Value) {
      const Code = this.GetScratchStatusCode(Value);

      const Item = this.ScratchStatusOptions.find(
        (Option) => Option.Value === Code,
      );

      return Item ? Item.Label : Value || "-";
    },

    GetScratchStatusColor(Value) {
      const Colors = {
        SUCCESS: "#52c41a",
        WRONG: "#f5222d",
        DUPLICATE: "#faad14",
        BLOCK: "#f5222d",
        BLACKLIST: "#f5222d",
        ENDDATE: "#f5222d",
        NOTYET: "#f5222d",
      };

      return Colors[this.GetScratchStatusCode(Value)] || "#999";
    },

    HasVoucherBeenSent(Record) {
      if (!Record || Record.IsCashout === true) {
        return false;
      }

      const Status = String(
        Record.Voucher_Distribution_Final_Status || ""
      ).toUpperCase();

      /*
       * Response ID / tracking ID là dấu hiệu chắc chắn request đã được gửi.
       * WAITING_DLR / DELIVERED / FAILED cũng là các trạng thái sau khi đã gửi.
       * NOT_SENT / SEND_FAILED được xem là chưa gửi thành công sang nhà cung cấp.
       */
      if (
        Record.Voucher_Distribution_Response_ID ||
        Record.Voucher_Distribution_Tracking_ID
      ) {
        return true;
      }

      return [
        "WAITING_DLR",
        "DELIVERED",
        "FAILED",
      ].includes(Status);
    },

    ShouldShowVoucherFinalStatus(Record) {
      return (
        this.IsSuccessScratch(Record && Record.Scratch_Status) &&
        this.HasVoucherBeenSent(Record)
      );
    },

    GetVoucherFinalStatusLabel(Record) {
      const Status = String(
        (Record && Record.Voucher_Distribution_Final_Status) || ""
      ).toUpperCase();

      if (Status === "DELIVERED") {
        return "KH ĐÃ NHẬN";
      }

      return "KH CHƯA NHẬN";
    },

    GetVoucherFinalStatusColor(Record) {
      const Status = String(
        (Record && Record.Voucher_Distribution_Final_Status) || ""
      ).toUpperCase();

      if (Status === "DELIVERED") return "#52c41a";
      if (Status === "FAILED") return "#f5222d";

      return "#faad14";
    },

    ShouldShowVoucherCapture(Record) {
      return (
        this.IsSuccessScratch(Record && Record.Scratch_Status) &&
        this.HasVoucherBeenSent(Record)
      );
    },

    GetVoucherCaptureStatusLabel(Value, Record) {
      const Status = String(
        Value ||
        (Record && Record.Voucher_Distribution_Capture_Status) ||
        ""
      ).toUpperCase();

      if (Status === "SUCCESS") return "ĐÃ CÓ ẢNH";
      if (Status === "PROCESSING") return "ĐANG LẤY ẢNH";
      if (Status === "FAILED") return "LẤY ẢNH LỖI";

      return "CHƯA CÓ ẢNH";
    },

    GetVoucherCaptureStatusColor(Value, Record) {
      const Status = String(
        Value ||
        (Record && Record.Voucher_Distribution_Capture_Status) ||
        ""
      ).toUpperCase();

      if (Status === "SUCCESS") return "#52c41a";
      if (Status === "PROCESSING") return "#1890ff";
      if (Status === "FAILED") return "#f5222d";

      return "#faad14";
    },

    IsSuccessScratch(Value) {
      return this.GetScratchStatusCode(Value) === "SUCCESS";
    },

    GetDownloadFilename(Response) {
      const Suggested = Response.headers.get("X-Suggested-Filename");

      if (Suggested) {
        return Suggested;
      }

      const Disposition = Response.headers.get("Content-Disposition") || "";

      const Match = /filename\*?=(?:UTF-8''|\\")?([^\\";]+)/i.exec(Disposition);

      if (Match && Match[1]) {
        try {
          return decodeURIComponent(Match[1]);
        } catch (Error) {
          return Match[1];
        }
      }

      return "Entry_Report.zip";
    },
    ClearExportAlert() {
      this.ExportAlert = {
        Visible: false,
        Type: "info",
        Message: "",
        Description: "",
      };
    },

    ShowExportAlert(Type, Message, Description) {
      this.ExportAlert = {
        Visible: true,
        Type: Type || "info",
        Message: Message || "",
        Description: Description || "",
      };
    },

    async ExportReport() {
      this.ClearExportAlert();
      this.Exporting = true;

      try {
        const Data = this.BuildRequestData();

        delete Data.Page;
        delete Data.PageSize;

        const Response = await this.$PostAPI("/report/export", Data, {
          responseType: "blob",

          ReturnResponse: true,
        });

        const ContentType = Response.headers["content-type"] || "";

        /*
         * BE có thể trả JSON lỗi,
         * nhưng vì responseType=blob nên axios
         * vẫn nhận nó dưới dạng Blob.
         */
        if (ContentType.includes("application/json")) {
          const Text = await Response.data.text();

          let ErrorResult = {};

          try {
            ErrorResult = JSON.parse(Text);
          } catch (Error) {
            // ignore
          }

          throw new Error(
            ErrorResult && ErrorResult.Message
              ? ErrorResult.Message
              : "Không xuất được báo cáo.",
          );
        }

        const BlobData = Response.data;

        let FileName = Response.headers["x-suggested-filename"] || "";

        /*
         * Fallback Content-Disposition.
         */
        if (!FileName) {
          const Disposition = Response.headers["content-disposition"] || "";

          const Match = /filename="?([^"]+)"?/i.exec(Disposition);

          if (Match) {
            FileName = Match[1];
          }
        }

        if (!FileName) {
          FileName = "Entry_Report.zip";
        }

        const ObjectURL = window.URL.createObjectURL(BlobData);

        const Link = document.createElement("a");

        Link.href = ObjectURL;

        Link.download = FileName;

        document.body.appendChild(Link);

        Link.click();

        Link.remove();

        window.URL.revokeObjectURL(ObjectURL);

        const ExportIssueCount = Number(
          Response.headers["x-report-export-issue-count"] || 0,
        );
        const DistributionIssueCount = Number(
          Response.headers["x-report-distribution-issue-count"] || 0,
        );
        const WaitingCount = Number(
          Response.headers["x-report-distribution-waiting"] || 0,
        );
        const FailedCount = Number(
          Response.headers["x-report-distribution-failed"] || 0,
        );
        const MissingDLRCount = Number(
          Response.headers["x-report-missing-dlr-count"] || 0,
        );
        const DLRPendingCount = Number(
          Response.headers["x-report-dlr-pending-count"] || WaitingCount || 0,
        );
        const DLRFailedCount = Number(
          Response.headers["x-report-dlr-failed-count"] || FailedCount || 0,
        );
        const MissingImageCount = Number(
          Response.headers["x-report-missing-image-count"] || 0,
        );
        const CaptureFailedCount = Number(
          Response.headers["x-report-capture-failed-count"] || 0,
        );

        if (ExportIssueCount > 0 || DistributionIssueCount > 0) {
          const IssueParts = [];
          if (MissingDLRCount) IssueParts.push(`thiếu tracking/DLR: ${MissingDLRCount}`);
          if (DLRPendingCount) IssueParts.push(`DLR chưa final: ${DLRPendingCount}`);
          if (DLRFailedCount) IssueParts.push(`DLR thất bại: ${DLRFailedCount}`);
          if (MissingImageCount) IssueParts.push(`thiếu ảnh: ${MissingImageCount}`);
          if (CaptureFailedCount) IssueParts.push(`capture ảnh lỗi: ${CaptureFailedCount}`);

          this.ShowExportAlert("warning", "Báo cáo đã xuất nhưng có Entry cần kiểm tra", `Có ${ExportIssueCount} Entry cần kiểm tra` +
              (IssueParts.length ? ` (${IssueParts.join(", ")}). ` : ". ") +
              "Chi tiết xem cột Export_Note và trạng thái Voucher trong Excel.");
        } else {
          this.ShowExportAlert("success", "Đã xuất báo cáo", "Không có cảnh báo export hoặc trạng thái Voucher.");
        }

        this.SearchReport();
      } catch (Error) {
        this.$message.error(Error.message || "Không xuất được báo cáo.");
      } finally {
        this.Exporting = false;
      }
    },
    // async ExportReport() {
    //   this.Exporting = true;

    //   try {
    //     const Data = this.BuildRequestData();

    //     delete Data.Page;
    //     delete Data.PageSize;

    //     const Response = await fetch("/crm/api/report/export", {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       credentials: "include",
    //       body: JSON.stringify(Data),
    //     });

    //     const ContentType = Response.headers.get("Content-Type") || "";

    //     if (!Response.ok || ContentType.includes("application/json")) {
    //       const ErrorResult = await Response.json();

    //       throw new Error(
    //         ErrorResult && ErrorResult.Message
    //           ? ErrorResult.Message
    //           : "Không xuất được báo cáo.",
    //       );
    //     }

    //     const BlobData = await Response.blob();

    //     const FileName = this.GetDownloadFilename(Response);

    //     const ObjectURL = window.URL.createObjectURL(BlobData);

    //     const Link = document.createElement("a");

    //     Link.href = ObjectURL;
    //     Link.download = FileName;

    //     document.body.appendChild(Link);

    //     Link.click();
    //     Link.remove();

    //     window.URL.revokeObjectURL(ObjectURL);

    //     this.$message.success("Đã xuất báo cáo.");
    //   } catch (Error) {
    //     this.$message.error(Error.message || "Không xuất được báo cáo.");
    //   } finally {
    //     this.Exporting = false;
    //   }
    // },
  },
};
</script>

<style scoped>
.report-filter-card,
.report-table-card {
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.report-table-card {
  margin-top: 14px;
}

.distribution-alert {
  margin-top: 14px;
}

.distribution-note {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.35;
  white-space: normal;
}

.quick-date-actions {
  justify-content: center;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.quick-date-label {
  margin-right: 4px;
}

.report-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.report-title {
  color: #00507a;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.report-subtitle {
  margin-top: 3px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
}

.report-total {
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 16px;
  background: #fafafa;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
  white-space: nowrap;
}

.report-filter-row > div {
  margin-bottom: 0;
}

.filter-label {
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.report-filter-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto 8px;
}

.report-filter-row {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-wrap: wrap;
  width: auto;
  max-width: 100%;
  gap: 10px;
  margin-bottom: 8px;
}

.report-filter-row:last-child {
  margin-bottom: 0;
}

.filter-block {
  min-width: 0;
}

.compact-date-picker {
  width: 135px;
}

.scratch-status-select {
  width: 300px;
}

.report-radio-group {
  display: inline-flex;
  width: auto;
  white-space: nowrap;
}

.report-radio-group .ant-radio-button-wrapper {
  flex: 0 0 auto;
  min-width: 0;
  padding: 0 7px;
  text-align: center;
  white-space: nowrap;
}

.report-radio-group .anticon {
  margin-right: 3px;
}

.toggle-filter-block {
  min-width: 145px;
}

.toggle-wrap {
  height: 32px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
}

.toggle-text {
  color: rgba(0, 0, 0, 0.58);
  font-size: 12px;
  white-space: nowrap;
}

.report-actions--center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 12px 0 14px;
}

.report-actions--center .export-button {
  margin-left: 14px;
  color: #fff;
  background: #fa8c16;
  border-color: #fa8c16;
}

.report-actions--center .export-button:hover,
.report-actions--center .export-button:focus {
  color: #fff;
  background: #ffa940;
  border-color: #ffa940;
}

/* Summary compact: giữ 1 hàng khi đủ chỗ, khoảng cách nhỏ */
.summary-row {
  display: flex !important;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 12px;
}

.summary-row > .ant-col {
  flex: 1 1 135px;
  width: auto !important;
  max-width: 190px;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.summary-row .report-summary-card {
  height: 100%;
  margin: 0;
}

.summary-row .report-summary-card >>> .ant-card-body {
  padding: 10px 12px;
}

.summary-row .report-summary-title {
  font-size: 11px;
  line-height: 16px;
}

.summary-row .report-summary-value {
  margin-top: 2px;
  font-size: 22px;
  line-height: 26px;
}

@media (max-width: 900px) {
  .scratch-status-select {
    width: 260px;
  }

  .summary-row > .ant-col {
    flex: 1 1 30%;
    max-width: none;
  }
}

@media (max-width: 600px) {
  .report-filter-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  .filter-block {
    width: 100%;
  }

  .filter-block-scratch,
  .toggle-filter-block {
    grid-column: 1 / -1;
  }

  .compact-date-picker,
  .scratch-status-select {
    width: 100%;
  }

  .report-radio-group {
    display: flex;
    width: 100%;
  }

  .report-radio-group .ant-radio-button-wrapper {
    flex: 1 1 0;
  }

  .report-actions--center {
    flex-wrap: wrap;
  }

  .summary-row > .ant-col {
    flex: 1 1 46%;
  }
}

.report-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
}

.export-button {
  margin-left: auto;
}

.request-time {
  display: inline-block;
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  white-space: nowrap;
}

.code_format {
  font-weight: bold;
}

.reward-status-tag {
  margin-top: 5px;
}

.mono-text {
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
}

.scratch-status {
  margin: 0;
  border-radius: 3px;
}

.scratch-status-success {
  font-weight: 600;
}

.report-summary-row {
  margin-bottom: 16px;
}

.report-summary-card {
  height: 100%;
  margin-bottom: 12px;
  text-align: center;
}

.report-summary-title {
  min-height: 34px;
  color: rgba(0, 0, 0, 0.58);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.25px;
}

.report-summary-value {
  margin-top: 6px;
  color: #00507a;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.15;
}


.report-link-tag {
  cursor: pointer;
  user-select: none;
}

.report-link-tag:hover {
  opacity: 0.78;
}

.report-image-preview {
  width: 100%;
  text-align: center;
}

.report-image-preview img {
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
}

@media (max-width: 767px) {
  .entry-report-page {
    padding: 8px;
  }

  .report-title-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .export-button {
    margin-left: 0;
  }
}

.report-table-wrap {
  overflow-x: auto;
}

.report-page :deep(.ant-table-fixed-left) {
  z-index: 3;
}

</style>


<style>
/*
 * a-notification render ngoài DOM của component nên scoped style không áp dụng.
 * Ép lại màu icon để tránh CSS global .warning/.error của App ghi đè.
 */
.ant-notification-notice-icon-warning {
  color: #faad14 !important;
}

.ant-notification-notice-icon-error {
  color: #f5222d !important;
}

.ant-notification-notice-icon-success {
  color: #52c41a !important;
}
</style>
